import useDevice from 'hooks/DesktopDevice.hook';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { RootState } from 'store/store';
import styled, { css } from 'styled-components';
import Box from 'styles/box/Box';
import CircularProgress from 'styles/circularProgress/CircularProgress';
import Typography from 'styles/typography/Typograpy';
import { Router } from './Router';

interface Props {
	className?: string;
}

const Overlay = styled(Box)`
	${({ theme }) => css`
		width: 100vw;
		height: 100vh;
		display: flex;
		position: absolute;
		justify-content: center;
		align-items: center;
		background-color: ${theme.palette.grey4.main};
		opacity: 0.3;
		z-index: 999999;
		flex-direction: column;
		row-gap: 1rem;
	`}
`;

export const Frame: React.FC<Props> = (props = {}) => {
	const progressIndicator = useSelector(
		(state: RootState) => state.progressIndicator,
	);

	const { isDesktop } = useDevice();

	return (
		<>
			{progressIndicator?.isLoading ? (
				<Overlay>
					<CircularProgress color="inherit" />
					<Typography variant="subheadline1" sx={{ width: '80%' }}>
						{progressIndicator?.loadingMessage}
					</Typography>
				</Overlay>
			) : null}
			<Box
				sx={{
					width: '100vw',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
			>
				<Box
					maxWidth={'lg'}
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
						height: '100%',
						marginLeft: isDesktop ? '160px' : '120px',
						marginRight: isDesktop ? '100px' : '60px',
					}}
				>
					<BrowserRouter>
						<Router />
					</BrowserRouter>
				</Box>
			</Box>
		</>
	);
};
